/**
 * Application constants
 */

export const isPreview = window.location.search.includes("isPreview=true");